import {useForm} from "react-hook-form";
import React, {useContext, useEffect, useState} from "react";
import {Paper} from "@mui/material";
import strings from "../../../localization";
import InventoryForm from "../../../Components/Forms/Pages/AssetManagement/Inventory/InventoryForm";
import DrawerContext from "../../../Context/DrawerContext";
import {
  addInventory,
  getInventoryLocations,
  getInventoryTypes,
} from '../../../Services/AssetManagement/InventoryService';
import LinearProgress from '@mui/material/LinearProgress';
import SnackbarContext from "../../../Context/SnackbarContext";

const formRules = {
    'value': {required: true}, 'quantity': {required: true}, 'lowStockTrashold': {required: true},
}

const AddInventory = (props) => {

    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm({});
    const {data, control, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const [inventoryLocations, setInventoryLocations] = useState(0);
    const [inventoryTypes, setInventoryTypes] = useState(0);

    useEffect(() => {
        setDrawerTitle(strings.pages.assetManagement.inventory.addInventory.pageTitle);
    });

    useEffect(() => {
        fetchInventoryLocations();
        fetchInventoryTypes(); 
    },[])

    const fetchInventoryLocations = (term = "") => {
        getInventoryLocations({term}).then((response) => {
            if (!response || !response.ok) {
              return;
            }
            setInventoryLocations(response.data.result);
          });
    }

    const fetchInventoryTypes = (term = "") => {
        getInventoryTypes({term}).then((response) => {
            if (!response || !response.ok) {
              return;
            }
            setInventoryTypes(response.data.result);
          });
    }

    const onSubmit = (data) => {

        setShowLoader(true);

        addInventory(data).then(response => {
            setShowLoader(false);

            if (!response || !response.ok) {
                showMessage(strings.commonMessages.errorAdding, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.addingSuccessful, 'success');
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <InventoryForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue}
                inventoryTypes = {inventoryTypes}
                inventoryLocations = {inventoryLocations}
                errors={errors} data={data} form={form}
                onLocationChangeFilter={fetchInventoryLocations}
                onTypeChangeFilter={fetchInventoryTypes}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}/>
        </Paper>
    </div>
}

export default AddInventory;